module.exports = __webpack_public_path__ + "static/media/hdi-logo.ab0e8d12.svg";